import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import PropertyCard from "./PropertyCard";

type InfoboxProps = {
  currentProperty: any;
  open: boolean;
  close: () => void;
};

const ProperyMapInfobox = ({ currentProperty, open, close }: InfoboxProps) => {
  return (
    <Dialog open={open}>
      <CloseButton onClick={close}>
        <CloseRoundedIcon />
      </CloseButton>
      <Box display={"flex"} flexDirection={isMobile ? "column" : "row"}>
        <PropertyCard
          property={currentProperty[0] || {}}
          loading={false}
          index={0}
          size={".8rem"}
        />
      </Box>
    </Dialog>
  );
};

const Dialog = styled("div")<{ open: boolean }>`
  display: ${({ open }) => (open ? "block" : "none")};
  background-color: #fff;
  padding: 10px;
  z-index: 800;
  position: absolute;
  bottom: 15px;
  min-width: 70%;
  left: 50%;
  border-radius: 5px;
  transform: translateX(-50%);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

  @media (max-width: 600px) {
    min-width: 20rem;
  }
`;

const CloseButton = styled("button")`
  position: absolute;
  right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 9999;
`;

export default ProperyMapInfobox;
